import { render, staticRenderFns } from "./CheckboxPreference.vue?vue&type=template&id=c86a1664&lang=pug&"
import script from "./CheckboxPreference.vue?vue&type=script&lang=js&"
export * from "./CheckboxPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports